"use client"

import type React from "react"

import { BackButton } from "@/components/flow/BackButton"
import { NeloLogo } from "@/components/flow/NeloLogo"

interface NavBarProps {
  showBackButton?: boolean
  onBack?: () => void
}

export const NavBar: React.FC<NavBarProps> = ({ showBackButton = false, onBack }) => {
  return (
    <div className="flex items-center py-4">
      {showBackButton && onBack && <BackButton onClick={onBack} />}
      <NeloLogo />
      {showBackButton && <div className="w-14"></div>}
    </div>
  )
}
